export default "__VITE_ASSET__4a090156__"